namespace MSTrgovina.Common {
    export enum MessageType {
        Success = "Success",
        Info = "Info",
        Warning = "Warning",
        Error = "Error"
    }

    interface IMessageBoxItem {
        Title: string;
        Message: string;
        MessageType: string;
        TimeOut: number;
    }

    export class MessageBox {
        private static $container: JQuery = null;

        private static ensureContainer(): JQuery {
            if (!this.$container || this.$container.length === 0) {
                this.$container = $("#toast-container");
                if (this.$container.length === 0) {
                    this.$container = $("<div id=\"toast-container\" aria-live=\"polite\" aria-atomic=\"true\"></div>");
                    $("body").append(this.$container);
                }
            }
            return this.$container;
        }

        public static ShowMessage(title: string, message: string, messageType: MessageType, timeout: number = 5): void {
            let $container: JQuery = this.ensureContainer();
            let toastClass: string = this.getToastClass(messageType);
            let icon: string = this.getIcon(messageType);
            let id: string = "toast-" + Date.now();
            let displayTitle: string = title || this.getDefaultTitle(messageType);

            let $toast: JQuery = $(`
                <div id="${id}" class="toast ${toastClass}" role="alert" aria-live="assertive" aria-atomic="true" data-delay="${timeout * 1000}">
                    <div class="toast-content">
                        <div class="toast-icon">
                            <i class="material-icons">${icon}</i>
                        </div>
                        <div class="toast-text">
                            <div class="toast-title">${this.escapeHtml(displayTitle)}</div>
                            <div class="toast-message">${this.escapeHtml(message)}</div>
                        </div>
                        <button type="button" class="toast-close" data-dismiss="toast" aria-label="Zatvori">
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                </div>
            `);

            $container.append($toast);

            (<any>$toast).toast("show");

            $toast.on("hidden.bs.toast", function (): void {
                $(this).remove();
            });
        }

        public static ProcessMessageBoxItems(base64Items: string): void {
            if (!base64Items) {
                return;
            }

            try {
                let json: string = MSTrgovina.Common.Helpers.EncodingHelper.b64DecodeUnicode(base64Items);
                let items: IMessageBoxItem[] = JSON.parse(json);

                for (let i: number = 0; i < items.length; i++) {
                    let item: IMessageBoxItem = items[i];
                    this.ShowMessage(
                        item.Title,
                        item.Message,
                        (<any>MessageType)[item.MessageType],
                        item.TimeOut
                    );
                }
            } catch (e) {
                console.error("Failed to process MessageBox items", e);
            }
        }

        private static getToastClass(messageType: MessageType): string {
            switch (messageType) {
                case MessageType.Success: return "toast-success";
                case MessageType.Info: return "toast-info";
                case MessageType.Warning: return "toast-warning";
                case MessageType.Error: return "toast-error";
                default: return "toast-info";
            }
        }

        private static getIcon(messageType: MessageType): string {
            switch (messageType) {
                case MessageType.Success: return "check_circle";
                case MessageType.Info: return "info";
                case MessageType.Warning: return "warning";
                case MessageType.Error: return "error";
                default: return "info";
            }
        }

        private static getDefaultTitle(messageType: MessageType): string {
            switch (messageType) {
                case MessageType.Success: return "Uspjeh";
                case MessageType.Info: return "Informacija";
                case MessageType.Warning: return "Upozorenje";
                case MessageType.Error: return "Greška";
                default: return "";
            }
        }

        private static escapeHtml(text: string): string {
            if (!text) {
                return "";
            }
            return $("<div>").text(text).html();
        }
    }
}
